import React, { useEffect,useState } from "react";

import homeBg from "../../assets/bg/guanwang_bg.jpg";
// import homeCenter from "../../assets/bg/guanwang_center.svg";
import homeCenter from "../../assets/bg/icon_center.png";
import logo from "../../assets/bg/logo.png";
import location from "../../assets/bg/location.png";
import contact from "../../assets/bg/contact.png";
import qiYeWX from "../../assets/bg/qiye_contact.png"
import "./index.less";
// const { TabPane } = Tabs
const Home = () => {
  useEffect(() => {
    sessionStorage.setItem("first", "0");
    if (
      sessionStorage.getItem("first") &&
      sessionStorage.getItem("first") === 0
    ) {
      setTimeout(() => {
        sessionStorage.setItem("first", "1");
      }, 10000 * 1000);
    }
  }, []);


   const [bc, setBc] = useState(false)

  return (
    <div className="home">
      <img src={homeBg} className="home-bg" alt="homeBg"></img>
      <div className="home-title">
        <img src={logo} alt="logo" className="logo" />
        <div className="logo-divider"></div>
        立足行业本体的全栈智能体平台提供商
      </div>
      <img src={homeCenter} alt="homeCenter" className="home-center"></img>
      <div className="home-footer">
        <div className="footer-left">
          <img src={logo} alt="logo" className="footer-bg" />
          <span className="touch">关注我们</span>
        </div>

        <div className="footer-mid1">
          <div className="footer-mid1-left">
            <div>
              <div className="footer-name1 footer-top">
                <span>上海众调信息科技股份有限公司</span>
                <span
                  className="touch-btn"
                  onMouseMove={() => {
                    setBc(true);
                  }}
                  onMouseLeave={() => {
                    setBc(false);
                  }}
                >
                  联系我们
                </span>
                <img
                  src={qiYeWX}
                  alt=""
                  className="qp"
                  style={{ display: bc ? "block" : "none" }}
                />
              </div>
              <div className="footer-name1">
                <img src={location} alt="location" className="location" />
                <span className="mt-10">上海 北京 广州 重庆</span>
              </div>
            </div>
            <div className="footer-name2 mt-10">上海市杨浦区国康路100号</div>
          </div>
          <img src={contact} alt="contact" className="footer-contact-img"></img>
        </div>
        <div className="p-12 div-flex">
          <div className="footer-name2">上海国际设计中心东楼11楼</div>
          <span
            className="p-12 underline"
            onClick={() => {
              window.open("https://beian.miit.gov.cn/");
            }}
          >
             沪ICP备15012794号-1
          </span>
        </div>
        <div className="footer-name2 div-flex">
          <span>021-6589 0077</span>
          <span
            className="p-12 underline"
            onClick={() => {
              window.open(
                "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002002975",
              );
            }}
          >
            沪公网安备31011002002975号
          </span>
        </div>
        <div className="footer-name2 div-flex">
          <span>mkt@unicdata.com</span>
          <span className="p-12">
            CopyRight © 2015-2026 All Rights Reserved
          </span>
        </div>
      </div>
    </div>
  );
};

export default Home;
